export const validateNumberGreaterOrEqualThanZero = (input) => {
    // Attempt to convert the input to a number
    const number = Number(input);

    // Check if the conversion resulted in a valid number
    if (Number.isNaN(number)) {
        return false; // Not a valid number
    }

    // Check if the number is greater or equal than 0
    return number >= 0;
};

export const validateNumberBetweenZeroAndOnethousand = (input) => {
    // Attempt to convert the input to a number
    const number = Number(input);

    return number >= 0 && number <= 100000;
};

export const isNumberWithDecimal = (value) => {
    // Regular expression to match basic numbers (no dot allowed)
    const basicNumberRegex = /^\d+$/;
    return basicNumberRegex.test(value);
};

export const validateDecimal = (input) => {
    // Regular expression to match a number with at most 2 decimal places
    const regex = /^\d+(\.\d{1,2})?$/;
    return regex.test(input);
};
